module.exports = __webpack_public_path__ + "img/banner-zh.d2538176.png";